document.addEventListener('DOMContentLoaded', function(){
 
    var cart_count = document.querySelector('.cart-count-bubble span[aria-hidden="true"]').textContent;
    var build_box_widgets_wrapper = document.querySelector(".build-box-widgets-wrapper");
    if(cart_count > 0){
       build_box_widgets_wrapper.classList.add("bb-widget-off");
    }else{
       build_box_widgets_wrapper.classList.remove("bb-widget-off");
    }  
  
});

// cookie
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
let oldCheckArr = [];
function checkCookie() {
  let buildBoxArr = getCookie("buildBox");
  if (!buildBoxArr) {
    document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
      oldCheckArr.push(ele.id);
    });
    setCookie("buildBox", buildBoxArr, 20);
  } else {
    buildBoxArr = buildBoxArr.split(",");
    for (let i = 0; i < buildBoxArr.length; i++) {
     var buildBoxArr_selector_check =  document.querySelector('label[for="' + buildBoxArr[i] + '"]')
     if(buildBoxArr_selector_check){ 
       buildBoxArr_selector_check.click();
     }
    }
  }
}
checkCookie();

// def sub
if (document.querySelector("select#cart-build-box-sub")) {
  let optVal = document.querySelector("select#cart-build-box-sub").value;
  let build_box_sub = document.querySelector("select#build-box-sub")
  if(build_box_sub){
    build_box_sub.value = optVal;  
    //document.querySelector("select#build-box-sub").value = optVal;
    build_box_sub.dispatchEvent(new Event("change"));
  }  
} else {
  let optVal = document.querySelector("select#build-box-sub").value;
  document.querySelector("select#build-box-sub").value = optVal;
  document
    .querySelector("select#build-box-sub")
    .dispatchEvent(new Event("change"));
}

// build box tab
document.querySelectorAll(".bb-btn").forEach(function (ele) {
  ele.addEventListener("click", function () {
    let tabTitle = ele.closest(".bbh-title");
    document.querySelectorAll(".bbh-title").forEach(function (ele) {
      ele.classList.remove("active");
    });
    tabTitle.classList.add("active");
    let i = ele.dataset.index;
    document.querySelectorAll(".bb-tab-content").forEach(function (ele) {
      ele.classList.remove("active");
    });
    document
      .querySelector('.bb-tab-content[data-index="' + i + '"]')
      .classList.add("active");
  });
});

// build box accordian
document.querySelectorAll(".bbd-acc-title").forEach(function (ele) {
  ele.addEventListener("click", function () {
    let accMain = ele.closest(".bbd-acc-main");
    if (accMain.classList.contains("active-acc")) {
      accMain.classList.remove("active-acc");
      accMain.querySelector(".bbd-acc-content").style.height = 0 + "px";
    } else {
      document.querySelectorAll(".bbd-acc-main").forEach(function (ele) {
        ele.classList.remove("active-acc");
      });
      accMain.classList.add("active-acc");
      document.querySelectorAll(".bbd-acc-content").forEach(function (ele) {
        ele.style.height = 0 + "px";
      });
      let setHeight = accMain.querySelector(".bbd-acc-get").clientHeight;
      accMain.querySelector(".bbd-acc-content").style.height = setHeight + "px";
    }
  });
});

// build box close
document.querySelector("button.build-box-colse").addEventListener("click", function () {
    document.body.classList.remove("build-box-on");
    checkBuildWidget();
});

buildBoxInit();

async function defBuildBox(defBoxHandle) {
  document.querySelectorAll('.bbpaq-input[value="0"]').forEach(function (ele) {
    let lbl = ele.id;
    document.querySelector('[for="' + lbl + '"]').click();
  });
  let defBoxItem = null;
  let defBoxS = null;
  let accIndex = null;
  let oldCheckArr = getCookie("buildBox");
  if (defBoxHandle == "tampon-starter-box") {
    defBoxItem = "16,16,16";
    accIndex = "1";
  } else if (defBoxHandle == "tampons-with-liners") {
    defBoxItem = "16,16,16";
    defBoxS = "16";
    accIndex = "1,3";
  } else if (defBoxHandle == "pads-with-liners") {
    defBoxItem = "16,16,16";
    defBoxS = "16";
    accIndex = "2,3";
  } else {
    defBoxItem = "32,16,16";
    accIndex = "2";
  }
  accIndex = accIndex.split(",");
  defBoxItem = defBoxItem.split(",");
  if (!defBoxS == null) {
    defBoxS = defBoxS.split(",");
  }
  accIndex.forEach(function (val, i) {
    //console.log(defBoxItem+'defBoxItem'+defBoxS+'defBoxS');
    let accDiv = document.querySelector(
      '.bb-pro-accordian[data-index="' + val + '"]'
    );
    if (i == 1) {
      let lbl = accDiv.querySelector(
        '.bbpa-pro-main[data-index="1"] .bbpaq-input[value="' + defBoxS + '"]'
      ).id;
      accDiv.querySelector('[for="' + lbl + '"]').click();
    } else {
      defBoxItem.forEach(function (val, i) {
        i++;
        let lbl = accDiv.querySelector(
          '.bbpa-pro-main[data-index="' +
            i +
            '"] .bbpaq-input[value="' +
            val +
            '"]'
        ).id;
        accDiv.querySelector('[for="' + lbl + '"]').click();
      });
    }
  });
  await updateButton(
    document.querySelector("button.bb-button-main"),
    "Go To Cart",
    "bb-go-to-cart"
  );
  document.querySelector("button.bb-button-main").click();
}

// def box
function defBoxButtons() {
  document
    .querySelectorAll(".def-build-btn[add-build-btn]")
    .forEach(function (ele) {
      ele.addEventListener("click", function (evt) {
        this.classList.add("load");
        this.querySelector(".loading__spinner").classList.remove("hidden");
        let defBoxHandle = this.dataset.handle;
        //console.log(defBoxHandle);
        defBuildBox(defBoxHandle);
      });
    });
}
defBoxButtons();

//  build box open
buildBoxOpenButtons = function () {
  if (document.querySelector(".load[add-build-btn]")) {
    document
      .querySelector(".load[add-build-btn]")
      .querySelector(".loading__spinner")
      .classList.add("hidden");
    document.querySelector(".load[add-build-btn]").classList.remove("load");
  }
  document.querySelectorAll("[add-build-btn]").forEach(function (ele) {
    ele.addEventListener("click", function (evt) {
      evt.preventDefault();
      if (this.classList.contains("cart-build-edit")) {
        document.querySelector("button.drawer__close").click();
      }
      if (this.classList.contains("def-build-btn")) {
      } else {
        buildBoxInit();
        document.body.classList.add("build-box-on");
        var buildBoxOpen = document.querySelectorAll('.bbpa-pro-main .bbpa-pro-detail .bbpa-quatity-main input[type="radio"]');
        for (var i = 0; i < buildBoxOpen.length; i++) {
            if (buildBoxOpen[i].value == '0') {           
                 buildBoxOpen[i].click();             
            }        
        }
        setTimeout(function(){
          var cart_count = document.querySelector('.cart-count-bubble span[aria-hidden="true"]').textContent;
          if(cart_count > 0){
             document.querySelector('.main-build-box-popup').classList.remove('hide');
          }else{
             document.querySelector('.main-build-box-popup').classList.add('hide');
            document.querySelector('.main-build-box-popup').classList.remove('items-added-in-card');
          }
          document.querySelector('.build-box-popup svg.feather.feather-x-circle').addEventListener('click', function() {
              document.querySelector('.main-build-box-popup').classList.add('hide');
              document.querySelector('.main-build-box-popup').classList.add('items-added-in-card');
          });
       },1000); 
      }
    });
  });
  // donation box input
  if (
    document.querySelector(".impact-box-price-row .ctm-quantity-main select")
  ) {
    document
      .querySelector(".impact-box-price-row .ctm-quantity-main select")
      .addEventListener("change", function () {
        let cartItems = document.querySelector("cart-drawer-items");
        this.closest(".impact-box-info-main")
          .querySelector("button")
          .classList.add("hidden");
        this.closest(".impact-box-info-main")
          .querySelector(".loading__spinner")
          .classList.remove("hidden");
        cartItems.updateQuantity(
          this.dataset.index,
          this.value,
          document.activeElement.getAttribute("name"),
          this.dataset.quantityVariantId
        );
      });
  }
  // shipping info btn
  if (document.querySelector(".sinfo")) {
    document.querySelector(".sinfo").addEventListener("click", function () {
      document.querySelector(".shipping-info-text").style.display = "flex";
      setTimeout(function () {
        document.querySelector(".shipping-info-text").style.display = "none";
      }, 1500);
    });
  }
  // turm check box
  if (document.querySelector("input#check-trums")) {
    document
      .querySelector("input#check-trums")
      .addEventListener("change", function () {
        if (this.checked) {
          document
            .querySelector("#CartDrawer-Checkout")
            .setAttribute("form", "CartDrawer-Form");
        } else {
          document
            .querySelector("#CartDrawer-Checkout")
            .setAttribute("form", "false");
        }
      });
  }
  // checkout button
  if (document.querySelector("button#CartDrawer-Checkout")) {
    document
      .querySelector("button#CartDrawer-Checkout")
      .addEventListener("click", function () {
        if (!document.querySelector("input#check-trums").checked) {
          var spanTag = document.createElement("span");
          var textNode = document.createTextNode("Please agree to the T&C");
          spanTag.classList.add("tc-error-text");
          spanTag.appendChild(textNode);
          document.body.appendChild(spanTag);
          let scrTop = document.querySelector(
            ".check-trums input#check-trums"
          ).offsetTop;
          document
            .querySelector("div#CartDrawer .drawer__inner")
            .scroll(0, scrTop);
          setTimeout(() => {
            spanTag.style.bottom = "5%";
          }, 100);
          setTimeout(() => {
            spanTag.style.bottom = "-20%";
            setTimeout(() => {
              document.body.removeChild(spanTag);
            }, 1000);
          }, 3000);
        }
      });
  }
  // cart sub init
  if (document.querySelector("select#cart-build-box-sub")) {
    document
      .querySelector("select#cart-build-box-sub")
      .addEventListener("change", function (evt) {
        evt.preventDefault();
        document.querySelector("div#CartDrawer").classList.add("cart-loading");
        document.querySelector("select#build-box-sub").value = this.value;
        document
          .querySelector("select#build-box-sub")
          .dispatchEvent(new Event("change"));
        window.cartSub = true;
      });
  }

  // cart add on variants
  addOnVariants();
};
buildBoxOpenButtons();

// build box product accrodian
document.querySelectorAll(".bb-pro-acc-title").forEach(function (ele) {
  ele.addEventListener("click", function () {
    let pElement = this.closest(".bb-pro-accordian");
    if (pElement.classList.contains("its-off")) {
      pElement.classList.remove("its-off");
    } else {
      pElement.classList.add("its-off");
    }
  });
});

// build box input functions
function headQuatity(input) {
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    let value = ele.value;
    let thisAcc = ele.closest(".bb-pro-accordian");
    let setQuatity = 0;
    thisAcc.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
      setQuatity = Number(ele.value) + Number(setQuatity);
    });
    thisAcc.querySelector(".bb-pro-count").textContent = setQuatity;
  });
}

function showPackQuantity() {  
  var subsVal = document.querySelector('select#build-box-sub').value
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    let value = ele.value;
    let setEle = document.querySelector('.get-bb-data span.bb-item[data-input="' + ele.name + '"]');
    setEle.querySelector(".count").textContent = value;
    
    if (value == 0) {
      setEle.style.display = "none";
    } else {
      let elePrice = getElePrice(ele);
      setEle.querySelector(".thisprice").textContent = moneyFormate(elePrice);          
      setEle.style.display = "block";
         if (subsVal != "null") {
          let discountPercentage = elePrice / 10;
          discountPercentage = elePrice - discountPercentage;        
          setEle.querySelector(".itgSubscribedPrice").textContent = moneyFormate(discountPercentage); 
          setEle.querySelector(".thisprice").classList.add('comparePrice');
        }else{
           setEle.querySelector(".thisprice").classList.remove('comparePrice');
           setEle.querySelector(".itgSubscribedPrice").textContent = '';
        }
      
     
    }
  });
}

// total units of build box
function allUnits() {
  let aU = 0;
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    aU = Number(ele.value) + Number(aU);
  });
  document.querySelector(".bbmu-text").textContent = aU + " Items.";
  return aU;
}

// set input value
function setValue() {
  let buildBoxArr = [];
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    buildBoxArr.push(ele.id);
  });
  setCookie("buildBox", buildBoxArr, 20);
}

// quatity value check
function checkQuantity(input) {
  let tQuatity = allUnits();
  //console.log(tQuatity,'tQuatity')
  if (tQuatity > 0) {
    let getData = document.querySelector(".get-bb-data").innerHTML;
    document.querySelector(".bbfd-details-total-price-main").innerHTML =
      getData;
    document.querySelector(".bbfd-details-total-price-main").style.display =
      "block";
    document.querySelector(".build-box-empty-text").style.display = "none";
    document.querySelector(".bb-mobile-empty-text").style.display = "none";
    document.querySelector("button.bb-button-main").disabled = false;
    document.querySelector(".bb-mobile-price-text").style.display = "block";
  } else {
    document.querySelector(".bb-mobile-price-text").style.display = "none";
    document.querySelector(".bbfd-details-total-price-main").innerHTML = "";
    document.querySelector(".bbfd-details-total-price-main").style.display =
      "none";
    document.querySelector(".build-box-empty-text").style.display = "block";
    document.querySelector(".bb-mobile-empty-text").style.display = "block";
    document.querySelector("button.bb-button-main").disabled = true;
    document.querySelector('.build-box-subcription-main select#build-box-sub').value = '1563656365';
  }
}

// moneyFormate
function moneyFormate(price) {
  price = price / 100;
  let formattedPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(price);
  return formattedPrice;
}

// cart total price
async function cartTotalPrice() {
  let cartData = await getCart();
  let bbPrice = 0;
  let cdPrice = 0;
  for (let i = 0; i < cartData.items.length; i++) {
    let item = cartData.items[i];
    if (item.url.includes("selling_plan")) {
      if (item.properties["_buildbox"]) {
        bbPrice =
          item.selling_plan_allocation.compare_at_price * item.quantity +
          bbPrice;
      }
      cdPrice =
        item.selling_plan_allocation.compare_at_price * item.quantity + cdPrice;
    } else {
      if (item.properties["_buildbox"]) {
        bbPrice = item.price * item.quantity + bbPrice;
      }
      cdPrice = item.price * item.quantity + cdPrice;
    }
  }
  let cartPrice = cdPrice - bbPrice;
  return cartPrice;
  }




// shippingBar
async function shippingBar(input) {
  let buildBoxPrice = totalPrice();
  let cartPrice = await cartTotalPrice();
  buildBoxPrice = buildBoxPrice + cartPrice;
  let freeShippingPrice = document.querySelector(".bb-shipping-main").dataset.shippingPrice;
  if (freeShippingPrice <= buildBoxPrice) {
    document.querySelector(".bb-remain-shipping-text").textContent =
      "Congrats!! You qualify for free shipping!";
    document.querySelector("span.bb-shipping-bar").style.width = "100%";
  } else {
    let rPrice = freeShippingPrice - buildBoxPrice;
    let remainPrice = moneyFormate(rPrice);
    let onePart = freeShippingPrice / 100;
    let shippinProgress = 100 - rPrice / onePart;
    document.querySelector("span.bb-shipping-bar").style.width =
      shippinProgress + "%";
    if (remainPrice.includes(".00")) {
      remainPrice = remainPrice.replace(".00", " ");
    }
    remainPrice = remainPrice.trim();
    let hPrice = freeShippingPrice / 2;
    let shippingBarContent = `You’re only <span class="bbrfs-price">$50</span> away from free shipping!`;
    if (buildBoxPrice > 0) {
      if (hPrice > buildBoxPrice) {
        shippingBarContent = `Getting closer! Only <span class="bbrfs-price">${remainPrice}</span> away from free shipping!`;
      } else {
        shippingBarContent = ` Almost there! Only <span class="bbrfs-price">${remainPrice}</span> away from free shipping!`;
      }
    }
    document.querySelector(".bb-remain-shipping-text").innerHTML =
      shippingBarContent;
  }
}

//get selected variant price 
function getElePrice(ele) {
  let val = Number(ele.value);
  let getId = ele.dataset.getId;
  //console.log(getId, val)
  var pv = document.querySelector("#" + getId + ' option[value="' + val + '"]').dataset.pack;
  //console.log(pv,'pv',getId)
  pv = pv.split("+");
  let packPrice = 0;
  for (let i = 0; i < pv.length; i++) {
    let pT = pv[i].split("*");
    //console.log(pT[0],'ee')
    let pPrice = Number(ele.closest(".bbpa-pro-detail").querySelector('select option[value="' + pT[0] + '"]').dataset.price);
    //console.log(pT[0],'pT[0]',pPrice)
    let pQ = Number(pT[1]);
    packPrice = (pPrice * pQ) + packPrice;
  }
  return packPrice;
}

// get totalPrice of build box
function totalPrice(input) {
  let packTotalPrice = 0;
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    if (ele.value > 0) {
      let val = Number(ele.value);
     
      let getId = ele.dataset.getId;
      //console.log(getId);
      var pv = document.querySelector("#" + getId + ' option[value="' + val + '"]').dataset.pack;
      pv = pv.split("+");
      
      for (let i = 0; i < pv.length; i++) {
        let pT = pv[i].split("*");
        let pPrice = Number(ele.closest(".bbpa-pro-detail").querySelector('select option[value="' + pT[0] + '"]').dataset.price);
        let pQ = Number(pT[1]);
        let packPrice = pPrice * pQ;
        packTotalPrice = packPrice + packTotalPrice;
      }
    }
  });
  if (packTotalPrice > 0) {
    let bProPrice = Number(
      document.querySelector("#build-box-main").dataset.price
    );
    packTotalPrice = packTotalPrice + bProPrice;
       //console.log(bProPrice+'workw'+packTotalPrice);
  }
  let bbTotalPrice = moneyFormate(packTotalPrice);
  document.querySelector(".get-bb-data .build-box-main-price").textContent =
    bbTotalPrice;
  return packTotalPrice;
}

// get cart
async function getCart() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) {
      throw new Error("Failed to fetch cart data");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching cart data:", error);
    return null; // or handle the error as needed
  }
}

// CheckCart
async function CheckCart() {
  let cartData = await getCart();
  if (cartData != null) {
    let obj = cartData.items;
    if (obj.length > 0) {
      for (let i = 0; i < obj.length; i++) {
        let proObj = obj[i]["properties"]["_buildbox"];
        if (proObj === true) {
          return proObj;
          break;
        }
      }
    }
  }
}

// updateButton
async function updateButton(input) {
  let buildBoxInCart = await CheckCart();
  let newCheckArr = [];
  let oldCheckArr = getCookie("buildBox");
  let buildSub = null;
  let cartBuildSub = null;
  if (document.querySelector("select#cart-build-box-sub")) {   
    buildSub = document.querySelector("select#build-box-sub")
    if(buildSub){
      buildSub.value
      cartBuildSub = document.querySelector("select#cart-build-box-sub").value;
    }
    
  }
  oldCheckArr = oldCheckArr.split(",");
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    newCheckArr.push(ele.id);
  });
  let btn = document.querySelector("button.bb-button-main");
  if (
    (buildBoxInCart !== undefined &&
      JSON.stringify(newCheckArr) !== JSON.stringify(oldCheckArr)) ||
    buildSub != cartBuildSub ||
    window.cartSub == true
  ) {
    btn.querySelector("span.bb-button-text").textContent = "Update Cart";
    btn.setAttribute("id", "bb-update-cart");
    if (window.cartSub) {
      window.cartSub = false;
      btn.click();
    }
  } else if (
    buildBoxInCart !== undefined &&
    JSON.stringify(newCheckArr) === JSON.stringify(oldCheckArr)
  ) {
    btn.querySelector("span.bb-button-text").textContent = "Go To Cart";
    btn.setAttribute("id", "bb-go-to-cart");
  } else {
    btn.querySelector("span.bb-button-text").textContent = "ADD TO BAG";
    btn.setAttribute("id", "bb-add-to-cart");
  }
}

function buildBoxInit() {
  headQuatity();
  showPackQuantity();
  updateButton();
  shippingBar();
  totalPrice();
  devMethod();
  checkQuantity();
}

// subscription off
function subOff() {
  document.querySelector("select#build-box-sub").value = null;
  document
    .querySelector("select#build-box-sub")
    .dispatchEvent(new Event("change"));
}

document
  .querySelector(".build-box-sub")
  .addEventListener("change", function () {
    let val = this.value;

    document.querySelector("#build-box-sub").value = val;
    document
      .querySelector("select#build-box-sub")
      .dispatchEvent(new Event("change"));
  });

// subscription price
function subPrice(tPrice) {
  let oneP = tPrice / 100;
  let tenP = oneP * 10;
  let subPrice = tPrice - tenP;
  return subPrice;
}

// subscription change function
document
  .querySelector("select#build-box-sub")
  .addEventListener("change", function (select) {
    var subsVal = select.value
    devMethod();
  });

// delevary method change
function devMethod() {
  let subValue = document.querySelector("select#build-box-sub").value;
  let subE = document.querySelector("select#build-box-sub");
  let buildTotalPrice = totalPrice();
  let buildSubPrice = subPrice(buildTotalPrice);
  showPackQuantity();
  
  if (subValue != "null") {
    document.querySelector(".get-bb-data .build-box-cam-price").textContent =
      moneyFormate(buildTotalPrice);
    document.querySelector(
      ".bb-mobile-price-text-main .build-box-cam-price"
    ).textContent = moneyFormate(buildTotalPrice);
    document.querySelector(".get-bb-data .build-box-main-price").textContent =
      moneyFormate(buildSubPrice);
    document.querySelector(
      ".bb-mobile-price-text-main .build-box-main-price"
    ).textContent = moneyFormate(buildSubPrice);
    let subText = "";
    if (subE.selectedIndex > 0) {
      subText = subE.options[subE.selectedIndex].text.replace("(Save 10%)", "");
    }
    document.querySelector("span.bbmu-sub").textContent = subText;
    document.querySelector(".get-bb-data .box-subcription-text").textContent =
      subText;
    document.querySelectorAll(".build-box-price").forEach(function (ele) {
      ele.classList.add("sub-on");
    });
    // itg 23-07
    // $('p.build-b-f-ann').show();
    // $('p.build-b-s-ann').hide();
    // itg 23-07
  } else {
    // itg 23-07
    // $('p.build-b-s-ann').show();
    // $('p.build-b-f-ann').hide();
    // itg 23-07
    document.querySelector("span.bbmu-sub").textContent = "Buy Once";
    document.querySelector(".get-bb-data .box-subcription-text").textContent =
      "One-time purchase";
    document.querySelector(".get-bb-data .build-box-main-price").textContent =
      moneyFormate(buildTotalPrice);
    document.querySelector(
      ".bb-mobile-price-text-main .build-box-main-price"
    ).textContent = moneyFormate(buildTotalPrice);
    document.querySelector(".get-bb-data .build-box-cam-price").textContent =
      "";
    document.querySelector(
      ".bb-mobile-price-text-main .build-box-cam-price"
    ).textContent = "";
    document.querySelectorAll(".build-box-price").forEach(function (ele) {
      ele.classList.remove("sub-on");
    });
  }
  updateButton();
  checkQuantity();
}

// input chnage function
document.querySelectorAll(".bbpaq-input").forEach(function (ele) {
  ele.addEventListener("change", function () {
    buildBoxInit();
    setWidgetCookie();
  });
});

//build box create bundle
function createBundle() {
  let itemQuantity = [];
  let itemId = [];
  let subId = [];
  let checkCombo = false;
  let dayPadPack = document.querySelector(
    '[data-get-id="bb-quatity-mange-day-pads"]:checked'
  ).value;
  let nightPadPack = document.querySelector(
    '[data-get-id="bb-quatity-mange-night-pads"]:checked'
  ).value;
  let sub = document.querySelector("select#build-box-sub");
  if (dayPadPack == 16 && nightPadPack == 16) {
    checkCombo = true;
  }
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    if (ele.value > 0 && !ele.closest('.varinat-hide1')) {
      let val = Number(ele.value);
      //console.log(val,'val')
      let getId = ele.dataset.getId;
      if (checkCombo) {
        if (
          getId == "bb-quatity-mange-day-pads" ||
          getId == "bb-quatity-mange-night-pads"
        ) {
          return;
        }
      }
      var pv = document.querySelector(
        "#" + getId + ' option[value="' + val + '"]'
      ).dataset.pack;
      pv = pv.split("+");
      for (let i = 0; i < pv.length; i++) {
        let pT = pv[i].split("*");
        let pI = Number(
          ele
            .closest(".bbpa-pro-detail")
            .querySelector('select.b-var option[value="' + pT[0] + '"]').dataset
            .id
        );
        let pQ = Number(pT[1]);
        //console.log(ele.closest("pI",pI));
        let sI = Number(
          ele.closest(".bbpa-pro-detail").querySelector("select.b-sub").value
        );
        itemQuantity.push(pQ);
        itemId.push(pI);
        subId.push(sI);
      }
    }
  });

  if (checkCombo) {
    itemQuantity.push(1);
    itemId.push(42890803445933);
  }
  // let buildId = document.querySelector("#build-box-main").dataset.id;
  // itemQuantity.push(1);
  // itemId.push(buildId);

  let bundleItems = [];
  for (var i in itemId)
    if (sub.value != "null") {
      //console.log(sub.value,'sub.value')
      bundleItems.push({
        id: itemId[i],
        quantity: itemQuantity[i],
        selling_plan: sub.value,
        // properties: {
        //   _buildbox: true,
        //   _dynamicBoxIndex: 0,
        //   _dynamicBoxId: "53231504-688c-42da-b8ce-9ade65c0ee92",
        // },
      });
    } else {
      bundleItems.push({
        id: itemId[i],
        quantity: itemQuantity[i],
        properties: {
          _buildbox: true,
          _dynamicBoxIndex: 0,
          _dynamicBoxId: "53231504-688c-42da-b8ce-9ade65c0ee92",
        },
      });
    }

  let sections = ["cart-drawer", "cart-icon-bubble"];
  let buildBoxBundle = {
    items: bundleItems,
    sections: sections,
    sections_url: window.location.pathname,
  };
  return buildBoxBundle;
}

// loading btn
function loading(btn) {
  if (btn.classList.contains("loading")) {
    btn.classList.remove("loading");
    btn.disabled = false;
  } else {
    btn.classList.add("loading");
    btn.disabled = true;
  }
}

// build box add to cart
function bundleAddToCart(btn, nextText, changeId) {
  let buildBoxBundle = createBundle();
  //console.log(buildBoxBundle,'buildBoxBundle');
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(buildBoxBundle),
  })
    .then((response) => response.json())
    .then((data) => {
      var selling_plan_id = data.items[0].selling_plan_allocation.selling_plan.id
      //console.log(selling_plan_id,'data');
      // setTimeout(function(){ },2000);
      //document.querySelector('select#cart-build-box-sub option[value="'+selling_plan_id+'"]').setAttribute('selected','selected');
        
      setValue();
      window.updateCart(data);
      loading(btn);
      btn.querySelector("span.bb-button-text").textContent = nextText;
      btn.setAttribute("id", changeId);
      checkFreeItem();
      // Handle success, e.g., show a success message or redirect to the cart page
    })
    .catch((error) => {
      loading(btn);
      console.error("Error adding bundle to cart:", error);
      // Handle error, e.g., show an error message to the user
    });
}

// go to cart
function goToCart(btn) {
  document.body.classList.remove("build-box-on");
  setTimeout(function () {
    document.querySelector("a#cart-icon-bubble").click();
    if (btn) {
      loading(btn);
    }
    if (document.querySelector(".load[add-build-btn]")) {
      document
        .querySelector(".load[add-build-btn]")
        .querySelector(".loading__spinner")
        .classList.add("hidden");
      document.querySelector(".load[add-build-btn]").classList.remove("load");
    }
  }, 200);
}

// widget cookie
function setWidgetCookie() {
  let buildBoxArr = [];
  document.querySelectorAll(".bbpaq-input:checked").forEach(function (ele) {
    buildBoxArr.push(ele.id);
  });
  setCookie("buildBoxWidget", buildBoxArr, 1);
}
setWidgetCookie();

// widget check scroll
// document.addEventListener("scroll", function () {
//   let fHeight = document.querySelector(
//     ".shopify-section-group-footer-group"
//   ).offsetHeight;
//   let fTop = document.querySelector(
//     ".shopify-section-group-footer-group"
//   ).offsetTop;
//   let scrTop = pageYOffset + fHeight + 500;
//   if (scrTop > fTop) {
//    var build_box_widgets_wrapper = document.querySelector(".build-box-widgets-wrapper");
//    if(build_box_widgets_wrapper){ 
//       build_box_widgets_wrapper.classList.add("bb-widget-off");
//    }
//   } else {
//     if (document.querySelector(".build-box-widgets-wrapper.bb-widget-off")) {
//       document.querySelector('.build-box-widgets-wrapper').classList.remove('bb-widget-off');
//       checkBuildWidget();
//     }
//   }
// });

// build box widget
async function checkBuildWidget() {
  let fHeight = document.querySelector(
    ".shopify-section-group-footer-group"
  ).offsetHeight;
  let fTop = document.querySelector(
    ".shopify-section-group-footer-group"
  ).offsetTop;
  let scrTop = pageYOffset + fHeight + 500;
  if (scrTop < fTop) {
    // document
    //   .querySelector(".build-box-widgets-wrapper")
    //   .classList.add("bb-widget-off");
    let buildBoxArr = getCookie("buildBoxWidget");
    let checkBBVal = false;
    let cartOpen = false;
    buildBoxArr = buildBoxArr.split(",");
    for (let i = 0; i < buildBoxArr.length; i++) {
      if (document.querySelector('input[id="' + buildBoxArr[i] + '"]')) {
        let bbVal = document.querySelector(
          'input[id="' + buildBoxArr[i] + '"]'
        ).value;
        if (bbVal > 0) {
          checkBBVal = true;
          break;
        }
      }
    }
    if (
      document
        .querySelector("body.main-body")
        .classList.contains("overflow-hidden")
    ) {
      cartOpen = true;
    }
    let currentCart = await getCart();
    let checkInCart = false;
    for (let i = 0; i < currentCart.items.length; i++) {
      if (currentCart.items[i].handle == "build-a-box") {
        checkInCart = true;
      }
    }
    if (checkInCart && !cartOpen) {
      document.querySelector(".build-box-widget-main").classList.add("in-cart");
      //setTimeout(() => {
        //if (!document.body.classList.contains("overflow-hidden")) {
          // document
          //   .querySelector(".build-box-widgets-wrapper")
          //   .classList.remove("bb-widget-off");
        //}
     // }, 3000);
    } else if (checkBBVal && !cartOpen) {
      document
        .querySelector(".build-box-widget-main")
        .classList.remove("in-cart");
      //setTimeout(() => {
        // document
        //   .querySelector(".build-box-widgets-wrapper")
        //   .classList.remove("bb-create-widget");
        // if (!document.body.classList.contains("overflow-hidden")) {
        //   document
        //     .querySelector(".build-box-widgets-wrapper")
        //     .classList.remove("bb-widget-off");
        // }
      //}, 3000);
    } else {
      if (!cartOpen && !checkBBVal) {
        document
          .querySelector(".build-box-widget-main")
          .classList.remove("in-cart");
        document
          .querySelector(".build-box-widgets-wrapper")
          .classList.add("bb-create-widget");
        // setTimeout(function () {
        //   if (!document.body.classList.contains("overflow-hidden")) {
        //     document
        //       .querySelector(".build-box-widgets-wrapper")
        //       .classList.remove("bb-widget-off");
        //   }
        // }, 3000);
      }
    }
  }
}
function checkQty() {
  var input_selector = document.querySelector('.varinat-and-quantity-box quantity-input.quantity .quantity__input');
  if(input_selector){ 
    var qty_min_val = input_selector.getAttribute('min');
    if(qty_min_val == '0'){
      document.querySelector('.varinat-and-quantity-box form[action="/cart/add"] button[type="submit"]').classList.add('disabled');
    }else{
      const button = document.querySelector('.varinat-and-quantity-box form[action="/cart/add"] button[type="submit"]');
      if (button && button.classList.contains('disabled')) {
        button.classList.remove('disabled');
      }
    }
  }
}

setTimeout(function () {
  checkBuildWidget();
  checkQty();
}, 3000);

// update build box
async function updateBuildBox(btn, nextText, changeId) {
  let buildBoxInCart = await CheckCart();
  let currentCart = await getCart();
  let obj = currentCart.items;
  let updates = false;
  if (buildBoxInCart) {
    if (obj.length > 0) {
      let updates = {};
      for (let i = 0; i < obj.length; i++) {
        let proObj = obj[i]["properties"]["_buildbox"];
        if (proObj === true) {
          let Id = obj[i].key;
          updates[Id] = 0;
        }
      }
      if (updates) {
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            updateBuildBox(btn, nextText, changeId);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else {
        bundleAddToCart(btn, nextText, changeId);
      }
    }
  } else {
    bundleAddToCart(btn, nextText, changeId);
  }
}

// submit handler of build box
document
  .querySelector("button.bb-button-main")
  .addEventListener("click", function (evt) {
    evt.preventDefault();
    let btnId = this.id;
    let nextText = "Go To Cart";
    if (document.querySelector("select#build-box-sub").selectedIndex > 0) {
      loading(this);
      if (btnId == "bb-add-to-cart") {
        bundleAddToCart(this, nextText, "bb-go-to-cart");
      } else if (btnId == "bb-go-to-cart") {
        goToCart(this);
      } else {
        updateBuildBox(this, nextText, "bb-go-to-cart");
      }
    } else {
      alert("Please Select Delivery Option");
    }
  });

// remove Donation box
function removeDonation(doBox) {
  let cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  let dTitle = doBox.title.toLocaleLowerCase();
  let deleteItem = {
    id: String(doBox.id),
    quantity: 0,
    sections: cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  };
  if (dTitle.includes("donation")) {
    document.querySelector("div#CartDrawer").classList.add("cart-loading");
    let body = JSON.stringify(deleteItem);
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        window.updateCart(parsedState);
      });
  }
}

// update cart
window.updateCart = async function (data) {
  window.updateCartCount(data);
  let cart = await getCart();
  let cartDrawer = data.sections["cart-drawer"];
  cartDrawer = new DOMParser().parseFromString(cartDrawer, "text/html");
  let newCartDrawer = cartDrawer.querySelector("cart-drawer").innerHTML;
  document.querySelector("cart-drawer").innerHTML = newCartDrawer;
  if (cart.items.length > 0) {
    document.querySelector("cart-drawer").classList.remove("is-empty");
  } else {
    document.querySelector("cart-drawer").classList.add("is-empty");
  }
  setTimeout(() => {
    goToCart();
    window.sliderOn();
    buildBoxOpenButtons();
  });
};
 

// update cart count
window.updateCartCount = async function (data) {
  let cartData = await getCart();
  if (
    document.querySelector(".impact-box-price-row .ctm-quantity-main select")
  ) {
    if (cartData.items.length == 1) {
      removeDonation(cartData.items[0]);
    }
  }
  let cartCount = data.sections["cart-icon-bubble"];
  cartCount = new DOMParser()
    .parseFromString(cartCount, "text/html")
    .querySelector("#shopify-section-cart-icon-bubble");
  document.querySelector("a#cart-icon-bubble").innerHTML = cartCount.innerHTML;
   var cart_count = document.querySelector('.cart-count-bubble span[aria-hidden="true"]').textContent;
    var build_box_widgets_wrapper = document.querySelector(".build-box-widgets-wrapper");
    if(cart_count > 0){
       build_box_widgets_wrapper.classList.add("bb-widget-off");
    }else{
       build_box_widgets_wrapper.classList.remove("bb-widget-off");
    }  

  setTimeout(() => {   
    buildBoxOpenButtons();
  }, 500);
};

// check free item 
async function checkFreeItem() {
  if(document.querySelector('body.check-subscription')){
    let productfreeid = document.body.getAttribute("product-handle");
    let cartData = await getCart();
    let checkSubFree = false;
    for (let i = 0; i < cartData.items.length; i++) {
      if(cartData.items[i].url.includes('selling_plan')){
        checkSubFree = true;
        break;
      }
    }

    
    if(!document.querySelector('[free-item]') && checkSubFree){
      window.customAddToCart(productfreeid,1);
      //console.log('AddProduct')
      setTimeout(function(){
           $('p.custom-text-main').text('Free Zipper Pouch With All Subscriptions');
       },2500);
    }else{
      if(document.querySelector('[free-item]')){
        if(cartData.items.length == 1 || !checkSubFree){
            removeFreeItem();
            //console.log('RemoveProduct');
          }
      }
    }
  if(checkSubFree){
  //console.log('TRUEPRODUCT');
  }else{
    setTimeout(function(){
      $('p.custom-text-main').text('Are you sure? Subscribe for a free pouch.')
    },2500);
  }
    
    
  }
}
checkFreeItem();

// remove free item 
function removeFreeItem() {
    setTimeout(function(){
       $('p.custom-text-main').text('Are you sure? Subscribe for a free pouch.')
    },2500);
    document.querySelector('div#CartDrawer').classList.add('cart-loading');
    let productfreeid = document.body.getAttribute("product-handle");
  //console.log('productfreeid'+ productfreeid)
    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let update = {};
    update[productfreeid] = 0;
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        updates:update,
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      })
    })
    .then(response => {
      return response.json();
    }).then(response => {
      if(cart){
        window.updateCart(response);
      }else{
        window.location = window.routes.cart_url;
      } 
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
// order again js

orderAgain();
async function orderAgain() {
  if (location.href.includes("active-cart")) {
    document.querySelector(
      ".cart-count-bubble span[aria-hidden]"
    ).textContent = 1;
    document.querySelector(".cart-drawer").classList.add("cart-loading");
    document.querySelector(".cart-drawer").classList.add("cart-hide");
    let cart = await getCart();
    let cartItems = cart.items;
    let checkBuild = false;
    let itemQuantity = [];
    let itemId = [];
    for (let i = 0; i < cartItems.length; i++) {
      if (cartItems[i].handle == "build-a-box") {
        checkBuild = true;
      }
      itemQuantity.push(cartItems[i].quantity);
      itemId.push(cartItems[i].id);
    }
    if (checkBuild) {
      let bundleItems = [];
      for (var i in itemId)
        bundleItems.push({
          id: itemId[i],
          quantity: itemQuantity[i],
          // properties: {
          //   _buildbox: true,
          //   _dynamicBoxIndex: 0,
          //   _dynamicBoxId: "53231504-688c-42da-b8ce-9ade65c0ee92",
          // },
        });
      let sections = ["cart-drawer", "cart-icon-bubble"];
      let buildBoxBundle = {
        items: bundleItems,
        sections: sections,
        sections_url: window.location.pathname,
      };
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function (data) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(buildBoxBundle),
          })
            .then((response) => response.json())
            .then((data) => {
              window.updateCart(data);
              history.pushState({}, "", "https://www.itsaugust.co/");
            });
        },
      });
    }
  }
}

